import styled from 'styled-components'
import { Body1 } from '@components/Text'

export default styled.div`
  cursor: pointer;
  border-radius: 100px;
  box-shadow: 0px 4px 12px rgba(152, 152, 167, 0.25);
`

export const ButtonText = styled(Body1)`
  color: ${props => props.color || 'var(--buenos-aires-60);'};
`
